var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("accountDeletionHeader")))]),_c('br'),_c('i18n',{attrs:{"path":"accountDeletion.template","tag":"p"}},[_c('a',{attrs:{"slot":"link","href":"https://support.azena.com/hc"},slot:"link"},[_vm._v(_vm._s(_vm.$t("accountDeletion.linkLabel")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }